import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONFIRMATION_HEADERS_MESSAGES, CONFIRMATION_MESSAGES } from 'src/app/app-constants';
import { ConfirmationDialogComponent } from 'src/app/dashboard/components/dialogs/confirmaiton-dialog/confirmation-dialog.component';

export interface CanComponentDeactivate {
    confirm(): boolean;
}

@Injectable()
export class ConfirmationGuard implements CanDeactivate<CanComponentDeactivate> {
    constructor(public dialog: MatDialog) {}

    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        // Guard against null component (can happen if component factory fails)
        if (!component || typeof component.confirm !== 'function') {
            console.warn('ConfirmationGuard: component is null or does not have confirm method');
            return true; // Allow navigation if component is invalid
        }

        const IsNavigate = component.confirm();
        if (IsNavigate) {
            return true;
        } else {
            return this.confirm();
        }
    }

    confirm(): Observable<boolean> {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                action: CONFIRMATION_HEADERS_MESSAGES.navigateConfirm,
                msg: CONFIRMATION_MESSAGES.navigate,
            },
            disableClose: true,
        });
        return dialogRef.afterClosed().pipe(
            map((value) => {
                return value;
            })
        );
    }
}
